export const CLIENT_DOCUMENT_MAX_BYTES = 10000000;
export const CLIENT_DOCUMENT_MAX_FILES = 5;
export const CLIENT_DOCUMENT_UPLOAD_HELP = 'Choose up to 5 documents, 10 MB each.';

export const validateClientDocumentUpload = (files) => {
  if (!Array.isArray(files) || !files.length) return 'Choose at least one document.';
  if (files.length > CLIENT_DOCUMENT_MAX_FILES) return 'Choose no more than 5 documents.';
  if (files.some(file => !Number.isFinite(file.size) || file.size <= 0)) return 'Choose a non-empty document.';
  if (files.some(file => file.size > CLIENT_DOCUMENT_MAX_BYTES)) return 'Each document must be no larger than 10 MB.';
  return null;
};
